<template>
  <div>
    <v-card
      class="mx-auto fixed-header"
    >
      <v-app-bar
        dark
        class="fixed-header"
        style="background-color: #dbe4f3;color:black"
      >
        <!--      <v-app-bar-nav-icon></v-app-bar-nav-icon>-->
        <div style="margin-left: 25px;" class="circle-img">
          <img :src="get_user_image()" style="    width: 100%;"/>
        </div>
        <v-toolbar-title>
        <span class="router-name">
          {{$route.meta.name}}
        </span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn style="left:0;position: absolute" v-on:click="$router.go(-1)" v-if='$route.meta.name != "خانه"' icon>
          <v-icon color="black">mdi-chevron-left</v-icon>
        </v-btn>
      </v-app-bar>

    </v-card>
    <br>
    <br>
    <v-tabs
      v-model="tab"
      align-with-title
    >
      <v-tabs-slider color="yellow"></v-tabs-slider>
      <v-tab href="#home-tab" to="/home-tab">
        <v-icon>
          mdi-notebook-outline
        </v-icon>
      </v-tab>
      <v-tab href="#message-tab" to="/message-tab">
        <v-icon>
          mdi-message-text-outline
        </v-icon>
      </v-tab>
      <v-tab href="#profile-tab" to="/profile-tab">
        <v-icon>
          mdi-account-outline
        </v-icon>
      </v-tab>
      <v-tabs-items>
        <v-card flat>
          <v-card-text style="margin-bottom: 40px;overflow: auto;    height: 82vh;">
            <div class="text-center">
              {{branch_name}}
            </div>
            <div class="row requests" v-if="$i18n.locale=='fa'">

              <div v-if="accept_add_request" class="col-6">
                <span v-on:click="go_to_customer_info(false)">
                  <img src="../../../public/img/sabt_dar_shobe.png"/>
                </span>
              </div>
              <div v-if="accept_add_request" class="col-6">
                <span v-on:click="go_to_customer_info(true)">
                  <img src="../../../public/img/sabt_dar_mahal.png"/>
                </span>
              </div>

              <div class="col-6" v-on:click="go_to_referred_requests">
                <img src="../../../public/img/my_refers.png"/>
              </div>
              <div class="col-6">
                <img src="../../../public/img/shekaiat_logo.png"/>
              </div>

              <div v-if="accept_device" v-on:click="go_to_safir_devices()" class="col-6">
                <img src="../../../public/img/safir_logo.png"/>
              </div>
              <div class="col-6" v-on:click="go_to_report_referred_requests">
                <img src="../../../public/img/report_refered_request.png"/>
              </div>
              <div v-if="accept_all_request" class="col-6" v-on:click="go_to_search_all_requests">
                <img src="/img/AllRequests.png"/>
              </div>
              <div class="col-6" v-on:click="go_to_product_requests">
                <img src="/img/product_request.png"/>
              </div>
              <div class="col-6" v-on:click="go_to_buy_orders">
                <img src="/img/buy_orders.png"/>
              </div>
              <div class="col-6"  v-if="accounting_report" v-on:click="go_to_accounting_report">
                <img src="/img/AccountingReport.png"/>
              </div>

              <div class="col-6" v-on:click="go_to_morakhasi">
                <img src="/img/morakhasi.png"/>
              </div>

              <div class="col-6" v-on:click="go_to_pay_report">
                <img src="/img/request_accounting_report.png"/>
              </div>
            </div>
            <div class="row requests" v-if="$i18n.locale=='en'">

              <div v-if="accept_add_request" class="col-6">
                <span v-on:click="go_to_customer_info(false)">
                  <img src="/img/sabt_dar_shobe_tr.png"/>
                </span>
              </div>
              <div v-if="accept_add_request" class="col-6">
                <span v-on:click="go_to_customer_info(true)">
                  <img src="/img/sabt_dar_mahal_tr.png"/>
                </span>
              </div>

              <div class="col-6" v-on:click="go_to_referred_requests">
                <img src="/img/my_refers_tr.png"/>
              </div>
              <div class="col-6">
                <img src="/img/shekaiat_logo_tr.png"/>
              </div>

              <div v-if="accept_device" v-on:click="go_to_safir_devices()" class="col-6">
                <img src="/img/safir_logo_tr.png"/>
              </div>
              <div class="col-6" v-on:click="go_to_report_referred_requests">
                <img src="/img/report_refered_request_tr.png"/>
              </div>
              <div v-if="accept_all_request" class="col-6" v-on:click="go_to_search_all_requests">
                <img src="/img/AllRequests_tr.png"/>
              </div>
              <div class="col-6" v-on:click="go_to_product_requests">
                <img src="/img/product_request_tr.png"/>
              </div>
              <div class="col-6" v-on:click="go_to_buy_orders">
                <img src="/img/buy_orders_tr.png"/>
              </div>
              <div class="col-6" v-on:click="go_to_accounting_report">
                <img src="/img/AccountingReport.png"/>
              </div>
              <div class="col-6" v-on:click="go_to_morakhasi">
                <img src="/img/morakhasi.png"/>
              </div>
              <div class="col-6" v-on:click="go_to_pay_report">
                <img src="/img/request_accounting_report.png"/>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-tabs-items>
    </v-tabs>
    <div class="start-conversation" v-on:click="goToReminder()">
      <v-icon>
        mdi-bell
      </v-icon>
    </div>
  </div>

</template>
<script>
  import {bus} from '../../main.js'

  export default {
    data() {
      return {
        tab: null,
        branch_name:localStorage.getItem("branch_name"),
        app_version: process.env.VUE_APP_VERSION_CODE,
        accept_device: false,
        accept_add_request: false,
        accept_all_request: false,
        accounting_report: false,
      }
    },
    mounted() {
      this.config_firebase();
      this.check_accept_device()
      this.check_ZkCheckManageReport()
      this.check_add_request()
      this.check_all_request()
      this.technician_login()
      this.check_user_in_zoodkomak()
      Notification.requestPermission(permission => {
        if (permission === 'granted') {
          this.registerBackgroundSync()
        } else console.error("Permission was not granted.")
      })
    },
    methods: {
      registerBackgroundSync() {
        if (!navigator.serviceWorker) {
          return console.error("Service Worker not supported")
        }

        navigator.serviceWorker.ready
          .then(registration => registration.sync.register('syncAttendees'))
          .then(() => console.log("Registered background sync"))
          .catch(err => console.error("Error registering background sync", err))
      },
      goToReminder() {
        this.$router.push({name: 'ReminderList', params: {}})
      },
      config_firebase() {
        // var self = this;
        // try{
        //   this.$messaging.messaging.requestPermission().then(() => {
        //     console.log('Notification permission granted.');
        //
        //     // Get Token
        //     this.$messaging.db.app.messaging().getToken({vapidKey: "BP9_Qg8FqhjCVuttOnqcBmKnfE1Eu9m22xNb4dy8DEWKG90lDXN--n-ZCIoYgImZLe4oAGb-Iej0CD9rdvdzr-M"})
        //       .then((currentToken) => {
        //         if (currentToken) {
        //           console.log('client token', currentToken)
        //           self.send_token(currentToken);
        //           self.$messaging.messaging.onMessage((payload) => {
        //             console.log('Message received. ', payload);
        //             // ...
        //           });
        //           self.$messaging.db.app.messaging().onMessage((payload) => {
        //             console.log('Message received2. ', payload);
        //             // ...
        //           });
        //
        //         } else {
        //           console.log('No registration token available. Request permission to generate one.');
        //         }
        //       }).catch((err) => {
        //       console.log('An error occurred while retrieving token. ', err);
        //     })
        //   }).catch((err) => {
        //     console.log('Unable to get permission to notify.', err);
        //   });
        //
        // }catch (e) {
        //   console.log('error Request permission to generate one.',e);
        //
        // }
      },
      send_token(token) {
        console.log(localStorage.getItem('profile'))
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var device_id = JSON.parse(localStorage.getItem('profile')).UserDeviceNo

        const send_data = {
          UserId: user_id,
          DeviceId: device_id,
          Token: token,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/UpdateFirebaseToken', send_data, {show_pros: false})
          .then(response => {
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      check_user_in_zoodkomak() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var user_name = JSON.parse(localStorage.getItem('profile')).UserName

        const send_data = {
          MobileNo: localStorage.getItem("phone").replace("+98", ""),
          Pass: localStorage.getItem("password"),
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://panel.zoodkomak.com/jetToken/GetToken', send_data, {show_pros: false})
          .then(response => {
            localStorage.setItem('userId2', response.data.UserId)

            // const send_data = {
            //   UserName: user_name,
            //   UserId: response.data.UserId,
            //   MobileNo: localStorage.getItem("phone"),
            //   Password: localStorage.getItem("password"),
            // }
            var formData = new FormData();
            formData.append('UserName',user_name);
            formData.append('UserId',response.data.UserId);
            formData.append('MobileNo',localStorage.getItem("phone"));
            formData.append('Password',localStorage.getItem("password"));

            // this.axios.post('/Register' , send_data,{
            self.axios.post('https://cp.zoodkomak.com/api/check_user_in_zoodkomak', formData, {show_pros: false})
              .then(response => {
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              this.errors.push(e)
            })

          }).catch(e => {
          this.errors.push(e)
        })
      },
      go_to_customer_info(OnSite) {
        var PassingData = {on_site_service: OnSite}
        localStorage.setItem('request_data', JSON.stringify(PassingData))
        // this.$store.commit('set', ['request_data', PassingData])
        // this.$store.commit('toggleSidebarDesktop')
        // console.log(store.state.count) //
        this.$router.push({name: 'CustomerInfo', params: {}})
      },
      go_to_referred_requests() {
        this.$router.push({name: 'ReferredRequest', params: {}})
      },
      go_to_morakhasi() {
        this.$router.push({name: 'MorakhasiList', params: {}})
      },
      go_to_pay_report() {
        this.$router.push({name: 'RequestPayReportList', params: {}})
      },
      go_to_buy_orders() {
        this.$router.push({name: 'BuyOrdersList', params: {}})
      },
      go_to_report_referred_requests() {
        this.$router.push({name: 'ReportReferredRequest', params: {}})
      },
      go_to_search_all_requests() {
        this.$router.push({path: '/report-request/search-all-requests', params: {}})
      },
      go_to_safir_devices() {
        this.$router.push({name: 'SafirDevices', params: {}})
      },
      go_to_product_requests() {

        this.$router.push({name: 'ProductRequestFactors', params: {rec_id: 0}})
      },
      go_to_accounting_report() {

        this.$router.push({name: 'AccountingReport', params: {}})
      },
      check_accept_device() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/CheckAcceptDevice', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.accept_device = true
            } else {
              self.accept_device = false
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      check_ZkCheckManageReport() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
          Role: "CheckManageReport",
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ZkGetUserPermission', send_data, {})
          .then(response => {
            if (response.data.UserAllow) {
              self.accounting_report = true
            } else {
              self.accounting_report = false
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      check_add_request() {
        console.log(localStorage.getItem('profile'))
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/CheckCustomerRequest', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.accept_add_request = true
            } else {
              self.accept_add_request = false
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      check_all_request() {
        console.log(localStorage.getItem('profile'))
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/CheckSysAllReqs', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.accept_all_request = true
            } else {
              self.accept_all_request = false
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      technician_login() {
        var self = this
        var eddited_mobile = localStorage.getItem('phone')
        var password = localStorage.getItem('password')

        const send_data = {
          MobileNo: eddited_mobile,
          Password: password,
          "OsName": "PWA",
          "AppNo": "4",
          "OsVersion": "1",
          DeviceModel: 'android',
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/TechnicianLogin', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('version is ', self.app_version, response.data.newVersion.VersionCode)
              if (self.app_version < response.data.newVersion.VersionCode) {
                if ('serviceWorker' in navigator) {
                  caches.keys().then(function (cacheNames) {
                    cacheNames.forEach(function (cacheName) {
                      caches.delete(cacheName);
                    });
                  });
                }
                window.location.reload(true)

              }
            } else {
              localStorage.setItem('profile', '')
              localStorage.setItem('phone', '')
              localStorage.setItem('password', '')
              localStorage.setItem('party_id', '')
              self.$router.push({name: 'login', params: {}})

              bus.$emit('show_toast', [2000, response.data.msg])
            }
          }).catch(e => {
          // this.errors.push(e);
          // bus.$emit('show_toast', [2000, e])

        })
      },

    }
  }
</script>
